import '../styles/TopBar.css'

/**
 * Fixed header strip shown when logged in: country name, player name and
 * current balance (kept fresh by App's refreshProfile after each build).
 * Hidden when embedded in an iframe (e.g. GameDashboard integration).
 */
const TopBar = ({ profile }) => {
  // Hide user data when embedded in iframe on another site
  try {
    if (window.self !== window.top) return null
  } catch (_) {
    return null
  }

  const { country_name, player_name, balance } = profile || {}

  return (
    <div className="map-topbar pr-widget pr-pill pr-gold">
      {country_name && (
        <span className="topbar-item topbar-country" title="Pays">
          🏳️ {country_name}
        </span>
      )}
      {player_name && (
        <span className="topbar-item topbar-player" title="Joueur">
          👤 {player_name}
        </span>
      )}
      {balance != null && (
        <span className="topbar-item topbar-balance" title="Balance">
          💰 {Number(balance).toLocaleString('fr-FR')}
        </span>
      )}
    </div>
  )
}

export default TopBar
